import React, { useState, useContext, useEffect } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { Grid } from '@mui/material';
import { NumericFormat } from 'react-number-format';

import PageWrapper from 'src/layout/PageWrapper/PageWrapper';
import Page from 'src/layout/Page/Page';
import Humans from 'src/assets/img/scene4.png';
import HumansWebp from 'src/assets/img/scene4.webp';
import { demoPagesMenu, dashboardPagesMenu } from 'src/menu';
import { useTranslation } from 'react-i18next';

import { CardFooter, CardFooterLeft, CardFooterRight } from 'src/components/bootstrap/Card';
import Pagination, { PaginationItem } from 'src/components/bootstrap/Pagination';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import Card, { CardBody } from 'src/components/bootstrap/Card';
import { useSelector } from 'react-redux';
import { getRole } from 'src/redux/slices/user';

import Icon from 'src/components/icon/Icon';
import {
	BsWallet2,
	BsArrowBarUp,
	BsArrowBarDown,
	BsSearch,
	BsArrowClockwise,
} from 'react-icons/bs';

import { PaymentServices } from 'src/services/PaymentServices';
import ThemeContext from 'src/contexts/themeContext';
import useDeviceScreen from 'src/hooks/useDeviceScreen';
import TablePagination from '@mui/material/TablePagination';
import showNotification from 'src/components/extras/showNotification';
import ModalDetail from 'src/pages/presentation/dashboard/ModalDetail';
import ModalDeposit from './ModalDeposit';
import MoDalQrcode from './MoDalQrcode';

export const PER_COUNT = {
	10: 10,
	20: 20,
	50: 50,
	100: 100,
};

export default function DowlineSelf() {
	const role = useSelector(getRole);
	const { t } = useTranslation();
	const { asideStatus } = useContext(ThemeContext);
	const { width } = useDeviceScreen();
	const [nameTitleModal, setNameTitleModal] = useState('');
	const [isOpenModal, setIsopenModal] = useState(false);
	const [dataModal, setDataModal] = useState([]);
	const [totalAmount, setTotalAmount] = useState([]);
	const [downLineSelf, setDownLineSelf] = useState([]);
	const [meta, setMeta] = useState();
	const [perPage, setPerPage] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalItems, setTotalItems] = useState(0);
	const [totalPage, setTotalPage] = useState(0);
	const [dataCard, setDataCard] = useState([]);

	const [prefix, setPrefix] = useState('');
	const [timeQuery, setTimeQuery] = useState([
		moment().startOf('month'),
		moment().endOf('month'),
	]);
	const [status, setStatus] = useState('');

	const handleView = (item) => {
		setIsopenModal(true);
		setDataModal(item);
	};

	const handleRefresh = () => {
		fetchDownLineSelf();
		showNotification(
			<span className='d-flex align-items-center'>
				{/* <Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span> */}
			</span>,
			`${t('txt_the_latest_information')}`,
		);
	};

	const fetchDownLineSelf = () => {
		PaymentServices.getDownlineSelf()
			.then(({ data }) => {
				const arr1 = [
					{
						name: `${t('txt_available_alance')}`,
						balance: data?.balance,
						color: '#238FE9',
						icon: <BsArrowBarDown />,
					},
				];
				setTotalAmount(data?.balance);
				setDownLineSelf(data);

				const newArr = [...arr1];
				setDataCard(newArr);
			})
			.catch(() => {});
	};

	const convertDate = (data) => {
		const convert = moment(data).format('DD/MM/YYYY - HH:mm:ss');
		return convert;
	};

	const ccyFormat = (num) => {
		return `${typeof num === 'number' ? num?.toFixed(2) : '0.00'}`;
	};

	useEffect(() => {
		fetchDownLineSelf();
	}, [timeQuery, status, currentPage, perPage]);

	return (
		<PageWrapper title={dashboardPagesMenu.downlineself.text}>
			<Page>
				<div
					style={{ margin: asideStatus || width < 768 ? '' : '0rem 1.5rem' }}
					className='div_founding_container'>
					<div className='fw-bold h3'>{t('txt_finance')}</div>
					<div className='div_found_in_transection mt-3'>
						<div className='fw-bold h5'>{t('txt_financial_report')}</div>
						<div style={{ display: 'flex' }}>
							<Button
								onClick={() => handleRefresh()}
								className='btn_refresh'
								style={{ marginLeft: '8px' }}>
								<BsArrowClockwise size={15} />
								<span>{t('txt_refresh')}</span>
							</Button>
						</div>
					</div>

					{/* <Grid container spacing={2} sx={{ mt: '0.5rem', mb: '2rem' }}>
						<Grid
							item
							xs={12}
							md={12}
							xl={6}
							lg={6}
							className='fundin_date_rang'></Grid>
						<Grid item xs={12} md={12} xl={6} lg={6}>
							<div className='div_search' style={{ justifyContent: 'end' }}>
								<FormGroup>
									<Input
										placeholder=''
										className='input_search'
										type='text'
										value={prefix}
										onChange={(e) => setPrefix(e.target.value)}
									/>
								</FormGroup>
								<Button onClick={() => handleSearch()} className='btn_search'>
									<BsSearch size={15} />
									<span>{t('txt_search')}</span>
								</Button>
							</div>
						</Grid>
					</Grid> */}

					<Grid container spacing={1} sx={{ mt: '1rem' }}>
						{dataCard?.map((item) => {
							return (
								<Grid item xs={12} md={12} xl={4} lg={4}>
									<Card
										stretch
										className='card card-stretch-full border border-1 card_dashboard'>
										<CardBody className='d-flex align-items-center'>
											<div className='div_card_sec1'>
												<h4>
													{item?.icon}
													<span className='spn_txt_title_card'>
														{item?.name}
													</span>
												</h4>
												<NumericFormat
													style={{
														color: item?.color,
														fontWeight: 'bold',
														fontSize: '18px',
													}}
													value={ccyFormat(item?.balance)}
													thousandSeparator
													displayType={'text'}
												/>
											</div>
										</CardBody>
									</Card>
								</Grid>
							);
						})}
					</Grid>

					<div className='div_filter_found_in'></div>
					{downLineSelf?.payment?.length > 0 ? (
						<>
							<div className='div_table_found_in'>
								<table class='table table-striped'>
									<thead>
										<tr>
											<th scope='col'>{t('txt_create_at')}</th>
											<th scope='col'>{t('txt_name')}</th>
											<th scope='col'>{t('txt_balance')}</th>
											<th scope='col'>Deposit Fee</th>
											<th scope='col'>Status</th>
											<th scope='col' style={{ textAlign: 'center' }}>
												{t('txt_action')}
											</th>
										</tr>
									</thead>
									<tbody>
										{downLineSelf?.payment?.map((item, idx) => {
											return (
												<tr key={idx}>
													<th scope='row'>
														{convertDate(item?.createdAt)}
													</th>
													<td>{item?.payment_provider?.name}</td>
													<td>
														<NumericFormat
															value={ccyFormat(item?.balance)}
															thousandSeparator
															displayType={'text'}
														/>
													</td>
													<td>{item?.deposit_fee}</td>
													<td>
														<div class='form-check form-switch'>
															<input
																class='form-check-input'
																type='checkbox'
																role='switch'
																id='flexSwitchCheckChecked'
																checked={
																	item?.active_status
																		? true
																		: false
																}
															/>
														</div>
													</td>

													<td style={{ textAlign: 'center' }}>
														<BsSearch
															onClick={() => {
																setNameTitleModal(
																	'Dowline Self Detail',
																);
																handleView(item);
															}}
															className='btn_view'
														/>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>

								{/* <div className='div_filter_found_in'>
									<CardFooter style={{ overflow: 'scroll' }}>
										<CardFooterLeft>
											<span className='text-muted'>{getInfo()}</span>
										</CardFooterLeft>
										<CardFooterRight className='d-flex'>
											{totalPage > 0 && (
												// @ts-ignore
												<Pagination ariaLabel={'xxx'}>
													<PaginationItem
														isFirst
														isDisabled={!(currentPage - 1 > 0)}
														onClick={() => setCurrentPage(1)}
													/>
													<PaginationItem
														isPrev
														isDisabled={!(currentPage - 1 > 0)}
														onClick={() =>
															setCurrentPage(currentPage - 1)
														}
													/>
													{currentPage - 1 > 1 && (
														<PaginationItem
															onClick={() =>
																setCurrentPage(currentPage - 2)
															}>
															...
														</PaginationItem>
													)}
													{pagination()}
													{currentPage + 1 < totalPage && (
														<PaginationItem
															onClick={() =>
																setCurrentPage(currentPage + 2)
															}>
															...
														</PaginationItem>
													)}
													<PaginationItem
														isNext
														isDisabled={!(currentPage + 1 <= totalPage)}
														onClick={() =>
															setCurrentPage(currentPage + 1)
														}
													/>
													<PaginationItem
														isLast
														isDisabled={!(currentPage + 1 <= totalPage)}
														onClick={() => setCurrentPage(totalPage)}
													/>
												</Pagination>
											)}

											<Select
												style={{ width: 'auto' }}
												size='sm'
												ariaLabel='Per'
												onChange={(e) => {
													setPerPage(parseInt(e.target.value, 10));
													setCurrentPage(1);
												}}
												value={perPage.toString()}>
												{Object.keys(PER_COUNT).map((i) => (
													<Option key={i} value={i}>
														{i}
													</Option>
												))}
											</Select>
										</CardFooterRight>
									</CardFooter>
								</div> */}
							</div>
						</>
					) : (
						<div className='div_list_none fw-bold h5'>
							{t('txt_there_are_no_items')}
						</div>
					)}
				</div>
				<ModalDetail
					isOpen={isOpenModal}
					exit={() => {
						setIsopenModal(false);
						setDataModal([]);
					}}
					data={dataModal}
					name={nameTitleModal}
					t={t}
				/>
			</Page>
		</PageWrapper>
	);
}
